import React from 'react';
import styles from './AnimatedVisuals.module.css';

const AIVisual = () => {
  return (
    <div className={styles.visualContainer}>
      <div className={styles.aiHeader}>
        <div className={styles.aiIcon}>🧠</div>
        <span className={styles.aiTitle}>AI Neural Network</span>
      </div>
      <div className={styles.aiNetwork}>
        <div className={styles.aiNode} style={{ top: '20%', left: '10%' }}></div>
        <div className={styles.aiNode} style={{ top: '20%', left: '50%' }}></div>
        <div className={styles.aiNode} style={{ top: '20%', left: '90%' }}></div>
        <div className={styles.aiNode} style={{ top: '50%', left: '30%' }}></div>
        <div className={styles.aiNode} style={{ top: '50%', left: '70%' }}></div>
        <div className={styles.aiNode} style={{ top: '80%', left: '50%' }}></div>
        
        {/* Connections */}
        <svg className={styles.aiConnections} viewBox="0 0 200 150">
          <line x1="20" y1="30" x2="60" y2="30" className={styles.connection} />
          <line x1="100" y1="30" x2="180" y2="30" className={styles.connection} />
          <line x1="20" y1="30" x2="60" y2="75" className={styles.connection} />
          <line x1="100" y1="30" x2="140" y2="75" className={styles.connection} />
          <line x1="60" y1="75" x2="100" y2="120" className={styles.connection} />
          <line x1="140" y1="75" x2="100" y2="120" className={styles.connection} />
        </svg>
      </div>
      <div className={styles.aiLabel}>Processing Intelligence...</div>
    </div>
  );
};

export default AIVisual;

